import React, { useState } from 'react'
import styles from './CreateUserPage.module.css'
import Modal from 'react-modal';
import { useMutation, useQuery } from '@apollo/client';
import { CREATE_USER, GET_ALL_TIERS } from '../../services/graphql';


const CreateUserPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        organization: '',
        email: '',
        accessLevel: '',
        tier: undefined,
        canSubmitDistanceInvoices: 'No',
        customDistanceRate: '',
    });
    const [numTiers, setNumTiers] = useState();

    const customModalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'var(--theme-bg-elevated)',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
    };


    useQuery(GET_ALL_TIERS, {
        onCompleted(data) {
            setNumTiers(data.getAllTiers.body.length);
        },
        onError(error) {
            alert('Unable to load tiers.');
        },
    });

    const [createUser] = useMutation(CREATE_USER, {
        onCompleted(data) {
            if (data.createUser.status.statusCode == '200') setSuccess(true);
            else alert('Unable to save new user.');
        },
        onError(error) {
            alert('Unable to save new user.');
        }
    });

    const tierOptions = [];
    tierOptions.push(<option key={0} value="">Select Approval Tier</option>);
    for (let i = 1; i <= numTiers; i++) {
        tierOptions.push(<option key={i} value={i}>{i}</option>);
    }

    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const canSubmitDistanceInvoices = formData.canSubmitDistanceInvoices === 'Yes';
        const customDistanceRate = canSubmitDistanceInvoices && formData.customDistanceRate !== ''
            ? Number(formData.customDistanceRate)
            : null;

        if (customDistanceRate !== null && (!Number.isFinite(customDistanceRate) || customDistanceRate <= 0)) {
            alert('Custom distance rate must be greater than 0.');
            return;
        }

        const variables = {
            name: formData.name,
            email: formData.email,
            organization: formData.organization,
            accessLevel: formData.accessLevel,
            canSubmitDistanceInvoices,
            customDistanceRate,
        };

        if (formData.accessLevel == 'Approver') {
            createUser({variables: {
                ...variables,
                tierNumber: parseInt(formData.tier, 10),
            }})
        } else {
            createUser({ variables })
        }
    };

    const closeModal = () => {
        window.location.reload();
    };

    return (
        <div className={styles.pageContainer}>
            <h2 className={styles.title}>Create a New User</h2>
            <form className={styles.form} onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="name">Name*</label>
                    <input
                        className={styles.input}
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="organization">Organization*</label>
                    <input
                        className={styles.input}
                        type="text"
                        id="organization"
                        name="organization"
                        value={formData.organization}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="email">Email*</label>
                    <input
                        className={styles.input}
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="accessLevel">Access Level*</label>
                    <select
                        className={styles.input}
                        id="accessLevel"
                        name="accessLevel"
                        value={formData.accessLevel}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Access Level</option>
                        <option value="Supplier">Supplier/Employee</option>
                        <option value="Approver">Approver</option>
                        <option value="Manager">Manager</option>
                    </select>
                </div>
                {formData.accessLevel === 'Approver' && (
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Approval Tier*</label>
                        <select
                            className={styles.input}
                            id="tier"
                            name="tier"
                            value={formData.tier}
                            onChange={handleChange}
                            required
                        >
                            {tierOptions}
                        </select>
                    </div>
                )}
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor="canSubmitDistanceInvoices">
                        Allow Distance-Based Invoices*
                    </label>
                    <select
                        className={styles.input}
                        id="canSubmitDistanceInvoices"
                        name="canSubmitDistanceInvoices"
                        value={formData.canSubmitDistanceInvoices}
                        onChange={handleChange}
                        required
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>
                {formData.canSubmitDistanceInvoices === 'Yes' && (
                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="customDistanceRate">
                            Custom Distance Rate
                        </label>
                        <input
                            className={styles.input}
                            type="number"
                            id="customDistanceRate"
                            name="customDistanceRate"
                            min="0"
                            step="0.0001"
                            placeholder="Default"
                            value={formData.customDistanceRate}
                            onChange={handleChange}
                        />
                    </div>
                )}
                <button className={styles.submitButton} type="submit">Send Invitation</button>
            </form>
            <Modal
                isOpen={success}
                onRequestClose={closeModal}
                style={customModalStyles}
                contentLabel="Submission Result"
            >
                <button className={styles.closeButton} onClick={closeModal}>
                    <span className={styles.closeIcon}>x</span>
                </button>
                <h2 className={styles.successMessage}>You have successfully created a new user.</h2>
                <h2 className={styles.successMessage}>An invite will be sent to their email shortly.</h2>
            </Modal>
        </div>
    )
}

export default CreateUserPage;
